import api from "@/services/axios.js";

export const getVerificationStatistics = (
  fromDate?: string,
  toDate?: string,
) => {
  const params: Record<string, string> = {};
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  return api.get("/api/AdminVerification/verification-statistics", { params });
};

export const getAssignmentStatistics = (fromDate?: string, toDate?: string) => {
  const params: Record<string, string> = {};
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  return api.get(
    `/api/AdminVerification/driver-verification-summaries?fromDate=${fromDate}&toDate=${toDate}`,
  );
};

export const getQualityStatistics = (fromDate?: string, toDate?: string) => {
  const params: Record<string, string> = {};
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  return api.get(
    `/api/AdminVerification/driver-verification-quality?fromDate=${fromDate}&toDate=${toDate}`,
  );
};
